module.exports = __webpack_public_path__ + "img/VIP.cb2c4fa3.png";